import React from 'react';
import { Badge, Button, Spinner } from 'react-bootstrap';
import { FaEyeSlash, FaExclamationTriangle } from 'react-icons/fa';

/**
 * Component for rendering status badges with appropriate colors and toggle buttons
 */
const StatusBadge = ({ status, onToggle, isToggling, togglingId, id }) => {
    // Determine badge variant based on status
    let variant = 'secondary';
    if (status === 'PROCESSED') variant = 'success';
    if (status === 'FAILED' || status === 'ERROR') variant = 'danger';
    if (status === 'PENDING') variant = 'warning';
    if (status === 'IGNORED') variant = 'secondary'; // Using secondary (gray) instead of dark (black)
    
    // For FAILED or ERROR status, add the ignore button
    if (status === 'FAILED' || status === 'ERROR') {
        return (
            <div className="d-flex align-items-center">
                <Badge bg={variant} className="me-2">{status}</Badge>
                <Button 
                    variant="outline-secondary" 
                    size="sm" 
                    title="Mark as ignored"
                    onClick={() => onToggle(id)}
                    disabled={isToggling && togglingId === id}
                    style={{ padding: '0.15rem 0.4rem' }}
                >
                    {isToggling && togglingId === id ? (
                        <Spinner animation="border" size="sm" />
                    ) : (
                        <FaEyeSlash size={12} />
                    )}
                </Button>
            </div>
        );
    }
    
    // For IGNORED status, add a button to toggle back to FAILED
    if (status === 'IGNORED') {
        return (
            <div className="d-flex align-items-center">
                <Badge bg={variant} className="me-2">{status}</Badge>
                <Button 
                    variant="outline-secondary" 
                    size="sm" 
                    title="Mark as failed"
                    onClick={() => onToggle(id)}
                    disabled={isToggling && togglingId === id}
                    style={{ padding: '0.15rem 0.4rem' }}
                >
                    {isToggling && togglingId === id ? (
                        <Spinner animation="border" size="sm" />
                    ) : (
                        <FaExclamationTriangle size={12} />
                    )}
                </Button>
            </div>
        );
    }
    
    // For other statuses, just show the badge
    return <Badge bg={variant}>{status}</Badge>;
};

export default StatusBadge;
